module.exports = __webpack_public_path__ + "static/media/setup.2aed5ff7.png";